import React, {useEffect} from "react";
import { ModerationAction, ReportDTO } from "./models/moderation";
import { useOktaAuth } from '@okta/okta-react';
import { fetchReports, pushActionToBackend } from "./api/moderation";
import {  ReportsTable } from "./ReportsTable";
import { CircularProgress } from "@mui/material";

export function ModeratorDashboard() {
    const [reports, setReports] = React.useState<Array<ReportDTO>>([]);
    const [loading, setLoading] = React.useState(false);
    const { oktaAuth } = useOktaAuth();

    useEffect(() => {
        async function getReports() {
            const reportsResponse = await fetchReports(oktaAuth);
            setReports(reportsResponse);
        }
        getReports();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    async function addAction(reportID: string,
        action: Omit<ModerationAction, 'createdAt' | 'moderatorId'>): Promise<void> {
        setLoading(true);

        const moderatorId = (await oktaAuth.getUser()).email ?? "unknown";
        const updatedReport = await pushActionToBackend(
            reportID,
            {
                moderatorId,
                createdAt: new Date(),
                ...action,
            },
            oktaAuth
        );

        const index = reports.findIndex((report) => report.id === reportID);

        if (index !== -1) {
            setReports([
                ...reports.slice(0, index),
                updatedReport,
                ...reports.slice(index + 1),
            ]);
        }
        setLoading(false);
    }

    if (reports.length === 0) {
        return (
            <React.Fragment>
                <CircularProgress />
            </React.Fragment>
        )
    }

    return (
        <React.Fragment>
            { loading ? <CircularProgress />: <></> }
            <ReportsTable reports={reports} addAction={addAction}/>
        </React.Fragment>
    );
}